import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Avatar, CloseIcon } from "components";
import { useGetDoesHaveCustomerFullAccess } from "pages/modules/customer/context";
import { ThemeProvider } from "utilz/theme/ThemeProvider";

interface groupMemberChipProps {
  data: any;
  onDelete: (data: any) => void;
  borderRadius?: string;
}

const TextWithMaxLength = ({ text, maxLength }: any) => {
  const truncatedText =
    text.length > maxLength ? text.slice(0, maxLength) + ".." : text;

  return (
    <Typography variant="body-medium" sx={{ fontSize: "12px" }}>
      {truncatedText}
    </Typography>
  );
};

export const GroupMembersCustomChip = ({
  data,
  onDelete,
  borderRadius,
}: groupMemberChipProps) => {
  const haveFullAccess = useGetDoesHaveCustomerFullAccess();
  const theme = useTheme();
  return (
    <Stack
      direction={"row"}
      gap={"8px"}
      sx={{
        alignItems: "center",
        borderRadius: borderRadius || "8px",
        border: "1px solid #CCCCCC",
        display: "flex",
        padding: "4px 8px 4px 8px",
        // backgroundColor: "red",
        width: "121px",
      }}
    >
      <Avatar
        fullname={data.label}
        src={data.profile}
        sx={{
          width: "24px",
          height: "24px",
          aspectRatio: "1",
        }}
      />

      <Stack
        sx={{
          display: "flex",
          flex: "1",
          flexGrow: 1,
          flexShrink: 1,
          overflow: "hidden",
        }}
      >
        {/* <Typography variant="body-medium" sx={{ fontSize: "12px" }}>
          {data.label || ""}
        </Typography> */}

        {/* <TextWithMaxLength text={data.label || ""} maxLength={9} /> */}
        <Typography
          variant="body-medium"
          sx={{
            width: "50px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "12px",
          }}
        >
          {data.label || ""}
        </Typography>
        <Typography
          variant="body-medium"
          sx={{
            color: theme.palette.lightBg.low,
          }}
        >
          {data.subLabel || ""}
        </Typography>
      </Stack>

      {haveFullAccess && (
        <Box
          sx={{
            aspectRatio: "1",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={() => haveFullAccess && onDelete(data)}
        >
          <CloseIcon sx={{ fontSize: "16px" }} />
        </Box>
      )}
    </Stack>
  );
};
